import React from 'react';

const SelectInput = ({
  labelName,
  id,
  onChangeFunction,
  value,
  icon,
  minimal,
  options,
}) => {
  return (
    <div className={minimal ? 'form-minimal' : 'form-floating'}>
      {minimal && (
        <label htmlFor={id} className="form-label">
          {icon && <img src={icon} height={18} width={18} alt="input icon" />}
        </label>
      )}
      <select
        className={minimal ? 'form-control-mini' : 'form-control'}
        id={id}
        value={value}
        onChange={onChangeFunction}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {!minimal && (
        <label htmlFor={id} className="form-label">
          {icon && <img src={icon} height={18} width={18} alt="input icon" />}
          {labelName}
        </label>
      )}
    </div>
  );
};

export default SelectInput;
